import React from 'react'

import { BuildingInfoType } from '../../../common/validations'
import { useAPIGetBuildingInfoSuspense } from '../../api/apiHooks/useAPIGetBuildingInfoSuspense'

import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'

interface Data {
  buildingInfo: BuildingInfoType
}

export const BuildingViewDataLoader = ({
  children,
}: {
  children: (data: Data) => React.ReactNode
}) => {
  const { currentContractId } = useCurrentContract()

  const { data: buildingInfo } =
    useAPIGetBuildingInfoSuspense(currentContractId)

  return children({ buildingInfo })
}
